<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter4" id="p030">
<img alt="Decoration" class="w" id="id-2424732834601036816" src="Images/img0004.jpg"/>
</div>
<div class="pg-boilerplate" id="calibre_pb_1"></div>
<h2 class="nobreak" id="CHAPTER_III">CHAPTER III.<br class="calibre6"/>
<span class="fs">WHAT WON A BICYCLE.</span></h2>
<p class="calibre9">Despite bruises and sprains, skinned ankles and
scraped knees, Persis overcame the difficulties of riding
a bicycle in a comparatively short space of time, and
really met with fewer mishaps than usually fall to the
lot of the learner. This was largely due to the efforts
of Porter and Basil, who were indefatigable teachers,
and as Persis had no fear, and was a persistent young
woman, it was not long before she could be seen skimming
up and down the block with all the confidence in
the world.</p>
<p class="calibre9">“Look here,” said Porter, “I don’t see why you
don’t coax your father to give you a bicycle. I shouldn’t
mind what your grandmother thinks. The idea of it!
Old people like her are always fussing about new
fashions.”</p>
<p class="calibre9">Persis opened her eyes. “Why! but I couldn’t
enjoy having one if grandma felt bad about it. She
has always been so good to us. She is the dearest
grandma in the world.”</p>
<p class="calibre9">“Well, I shouldn’t let anybody’s old out-of-date<span id="Page_31" title="[Pg 31]"></span>
notions keep me from having a good time,” was Porter’s
reply, as he walked away.</p>
<p class="calibre9">Persis stood looking after him with a dawning sense
of his being rather a selfish nature. “I suppose he’d
be furious if he knew what I thought of him,” she
reflected. “I’ll let him know some day,” she inwardly
continued, her wrath rising.</p>
<p class="calibre9">A tapping on the window called her into the house.
It was Lisa who summoned.</p>
<p class="calibre9">“Mamma wants you, Persis,” she said. “We are
going to have a small family conclave.” And Lisa’s
eyes danced.</p>
<p class="calibre9">“What is it now? This family has a way of springing
surprises on a body which is confusing, to say the
least,” returned Persis, as she took her way down-stairs.</p>
<p class="calibre9">She and Lisa had long ago “made up.” Indeed,
their little squabbles were of almost daily occurrence
and did not prevent them from being really devoted to
each other. Persis was the more generous of the two,
although possessed of more real strength of character.
Lisa yielded her opinions easily; her pleasures she
grasped more closely. With Persis it was directly the
opposite, she could give up a prospective treat, but her
convictions were her own, and these she could not
forego, unless convinced, under pressure, of their error,
and even then it was difficult for her to confess it,
although tacitly she generally did so.</p>
<p class="calibre9">“Now, mamma, what is it this time?” inquired
Persis, as she dropped on a hassock near the window.</p>
<p class="calibre9">“It is just this. Papa must be in Washington for<span id="Page_32" title="[Pg 32]"></span>
a few days on business, and wants me to go with him.
He is also willing to take one of you girls, and the
question is, Which shall it be?”</p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">“‘Which shall it be? Which shall it be?</div>
<div class="verse1">I looked at John, John looked at me,’”</div>
</div>
</div>
</div>
<p class="no-indent">quoted Persis. “Oh, mamma, that is a terrible strain
upon unselfishness.” And she looked from one sister to
the other.</p>
<p class="calibre9">“I’ve never been to Washington,” began Mellicent,
“and I believe it would do me the most good.”</p>
<p class="calibre9">“I am the eldest, and I think it is my place,” came
from Lisa.</p>
<p class="calibre9">“And I. I have a friend there. You know Patty
Peters is there this winter, mamma.” And Persis
turned an eager face to her mother.</p>
<p class="calibre9">“Such reasonable claims,” laughed Mrs. Holmes.
“I am afraid you must draw lots for it.”</p>
<p class="calibre9">“So we will. That will be the fairest way,” maintained
Mellicent.</p>
<p class="calibre9">“Now, mamma, we won’t even tell you which we
decide it is to be, the longest or the shortest, so you
cannot exert an undue influence,” Lisa said.</p>
<p class="calibre9">Therefore, after a short conference in the corner, the
girls gathered around to scan the slips of paper which
Mrs. Holmes held in her hand.</p>
<p class="calibre9">“Lisa first, then Perse, then I, according to our
ages,” decided Mellicent, and with breathless interest
the lots were drawn.</p>
<p class="calibre9">“The longest! The longest, we decided. Who
has it?” exclaimed Lisa, holding up her slip.</p>
<p class="calibre9"><span id="Page_33" title="[Pg 33]"></span></p>
<p class="calibre9">“I! I! It is mine,” Persis announced, joyfully.
“Now I can go to see Patty Peters.” And she executed
a wild dance about the room.</p>
<p class="calibre9">“Patty Peters!” Lisa repeated, disdainfully. “It
always sounds so ridiculous, as if you were trying to
say Peter Piper.”</p>
<p class="calibre9">The joy faded out of Persis’s face, and she stood
curling the slip of paper around her finger, looking
from Lisa to her mother. It may have been fancy, for
Persis was keenly sensitive, but she thought she saw a
shade of regret on her mother’s face. “Of course
mamma would most enjoy having Lisa,” she said to
herself. “She is so handsome, and mamma could show
her off so finely to her Washington friends.” Persis
swallowed a lump in her throat, then went over to Lisa
and said, with eyes shining, “I’ll change with you.”</p>
<p class="calibre9">“Oh, Perse, you don’t mean it; you’re joking!”
responded Lisa.</p>
<p class="calibre9">Persis shook her head. “No. I happen to remember
that you have a new coat this winter, and
the most becoming hat you ever wore, so it seems a
wicked waste of material for you not to go. So I’ll
stay at home and ride the boys’ bikes.”</p>
<p class="calibre9">“I believe you’d rather do it,” returned Lisa, to
ease her conscience.</p>
<p class="calibre9">“I think I ought not to consent to the exchange,”
began Mrs. Holmes; but Persis was firm, and, having
her determination fixed, almost persuaded herself that
the staying at home was the more desirable.</p>
<p class="calibre9">Mellicent felt herself out of the question, and went
to grandma for sympathy, while one appreciative look<span id="Page_34" title="[Pg 34]"></span>
from her father made Persis very happy over her
sacrifice.</p>
<p class="calibre9">It was, therefore, in high spirits that the party took
leave. “Everything will go on much better than if I
had been left at home,” said Lisa, graciously. “You
are such a fine manager, Perse, and I do hate marketing.
Good-bye. I’ll write as soon as I get there.”
And with a nod and a smile Lisa disappeared from view.</p>
<p class="calibre9">Matters went on smoothly for the first day or two.
Persis was too busy with her lessons and her housewifely
duties to think of much else. The housemaid
had been with the family for several years and understood
the routine of work, while the girls could not
remember the time when old black Prue had not presided
over the kitchen. Besides, there was grandma
to decide upon important matters; so the responsibility
upon Persis’s shoulders was not very heavy.</p>
<p class="calibre9">The boys had been the chief source of anxiety; but
they had proved themselves to be comparatively obedient,
and, having been put upon their honor, were disposed
to conduct themselves becomingly, especially as
Mr. Holmes had told them they were expected to be
the protectors of the household.</p>
<p class="calibre9">Therefore the absence of three important members
of the family did not make such a material difference
in the daily life as might be supposed, and everything
went along smoothly for several days. But one afternoon
when Prue was out, Lyddy the housemaid gone
on an errand, and the boys were off at the base-ball
grounds something occurred to ruffle the serene flow
of events.</p>
<p class="calibre9"><span id="Page_35" title="[Pg 35]"></span></p>
<p class="calibre9">“Now we have the place all to ourselves, let’s
make some gingerbread, Mell,” suggested Persis.
“We’ll begin it before Lyddy comes back, and it will
be done before dark. We’ll give grandma a surprise;
she does enjoy warm gingerbread. Come on and let’s
see if there is a good fire.”</p>
<p class="calibre9">Mellicent heartily complied, and the two girls went
down into the neat, quiet kitchen to begin operations.
The fire was in rather a dubious state for baking, it
was discovered. “We’ll get a little wood and start it
up,” said Persis. “Suppose you go after the wood,
Mellicent, while I get the other things together.”
And Mellicent started for the cellar, while Persis went
to the pantry. The latter was energetically sifting
flour, when a clattering sound, a heavy fall, and a
pitiful cry reached her ears.</p>
<p class="calibre9">Running to the head of the stairs leading to the
cellar, she peered down into the dimness, calling,
“Mell, Mellicent, where are you?” A moan was the
only reply. “Oh, Mell!” reiterated Persis in alarm,
as she hastily took her way down the steep steps.
“What is the matter?”</p>
<p class="calibre9">At the foot of the steps Mellicent lay in a confused
heap. “Oh, you dear child! Oh, Melly! Are you
hurt?” And Persis tried to lift her sister.</p>
<p class="calibre9">“I feel queer,” replied Mellicent. “I believe I
have done something to my arm, I can’t raise it.”</p>
<p class="calibre9">Persis helped the little girl to her feet, and then,
half carrying her, she managed to get her up the stairway.
Mellicent’s white face showed that something
serious had really happened.</p>
<p class="calibre9"><span id="Page_36" title="[Pg 36]"></span></p>
<p class="calibre9">“Tell grandma,” she said, and then she fainted.</p>
<p class="calibre9">Afraid to leave her, and yet hardly knowing what
to do, Persis ran to the foot of the stairs and called,
loudly, “Grandma! Grandma! come quick!”</p>
<p class="calibre9">To see the baby of the family lying on the kitchen
floor, with closed eyes and looking so pale, terrified
Mrs. Estabrook, and she cried, “Oh, my child! what
is it? Run for the doctor.” And Persis flew out, forgetting
that she still wore her floury apron.</p>
<p class="calibre9">The doctor who lived a block away was not at home,
and back again ran Persis, out of breath.</p>
<p class="calibre9">By this time Mellicent’s consciousness was restored,
and she was sitting in her grandmother’s lap. “I am
afraid she has broken her arm,” announced Mrs. Estabrook,
in distress. “The doctor ought to see her at
once.”</p>
<p class="calibre9">“Dr. Wheeler isn’t at home,” informed Persis, distressedly.
“Oh, dear! what shall we do?”</p>
<p class="calibre9">“We must have some doctor right away,” declared
Mrs. Estabrook, and Persis darted out again. She
could not think for a moment where she would find
another physician, but she did remember that their
family doctor lived about ten blocks off. It seemed a
long way in her present state of perturbation. She
could walk there as quickly as she could go by a roundabout
car-route, she reflected. But here her eye caught
sight of Porter’s bicycle leaning against the side of the
porch. In another moment she had mounted and was
flying like the wind along the street, being back again
in less time than she could have dreamed, breathless
from her effort. “The doctor will be here right off,”<span id="Page_37" title="[Pg 37]"></span>
she made haste to notify. “I went to Dr. Armstrong’s.”</p>
<p class="calibre9">Mrs. Estabrook looked amazed. “In this time?” she
said.</p>
<p class="calibre9">“Oh, grandma! I didn’t know any other way, and
I went on Porter’s wheel.”</p>
<p class="calibre9">Grandma’s only reply was, “I am thankful that you
found him so quickly. We cannot tell what injury our
little girl may have sustained.”</p>
<p class="calibre9">The doctor, however, pronounced a simple fracture
of the arm to be the only damage done, and when the
broken member was skilfully set, and Mellicent was
put to bed, Persis sat down and cried from sheer
relief.</p>
<p class="calibre9">There was no gingerbread made that day, for Persis
sat by the little sufferer all the evening, until grandma
advised her to go to her lessons, saying that Mellicent
did not need two nurses.</p>
<p class="calibre9">“Oh, dear!” said Persis, tearfully; “if I had only
gone down-cellar myself, it would never have happened.
I can never forgive myself.”</p>
<p class="calibre9">“My dear child, you must not feel that way about
it. We should not blame ourselves for accidents which
are not the result of thoughtlessness nor wrong intention.
Your intentions were all right, and no one was
to blame. You were not giving Mellicent work to do
beyond her strength. She was as likely to fall in
going down for an apple, or to see the new kittens;
so don’t blame yourself.” Thus grandma comforted.</p>
<p class="calibre9">Persis was much cheered by this; but she devoted
every spare moment to entertaining the invalid.</p>
<p class="calibre9"><span id="Page_38" title="[Pg 38]"></span></p>
<p class="calibre9">It was thought best not to spoil the pleasure of the
absent ones by telling them of this misfortune, since
there was no real danger attending it, and after a few
days Mellicent rather enjoyed being the object of commiseration,
and thought she must look very interesting
with her arm in a sling made of a large silk handkerchief.
She was particular that the handkerchief
should be a delicate blue, which contrasted becomingly
with her golden curls and fair skin. She was, however,
a patient little girl, and only by a pathetic expression
showed when she suffered.</p>
<p class="calibre9">The boys were most gallant, and did all manner of
things to amuse her, so that probably she did not
really regret the accident any more than Persis did.</p>
<p class="calibre9">The travellers returned in due time, and of course
there was a great chatter to be heard when the three
sisters met together. Lisa had enjoyed every minute
of her visit,—so she expressed herself,—and she told
wonderful tales of the social delights Washington had
to offer.</p>
<p class="calibre9">It was the day after the return of the travellers that
Mellicent, who was still housed, stood anxiously awaiting
the appearance of Persis after school, and she
greeted her sister with, “I know an awfully nice something,
but I can’t tell it. Oh, Persis, you’ll be the
gladdest girl. There! I’ll let it out if I don’t stop. I
heard grandma talking to papa, and she said you had
been so good and thoughtful and self-sacrificing.”
Persis was blushing furiously. “Yes, she did,” continued
Mellicent; “and then she told me a secret.
No, I won’t tell; that would spoil it all.”</p>
<p class="calibre9"><span id="Page_39" title="[Pg 39]"></span></p>
<p class="calibre9">But a clattering up the steps and an excited summons
from Porter took both the girls down-stairs.
Porter was hopping around on one foot in a high state
of glee, while Basil was critically examining the different
parts of a shining new wheel which stood in the
hall.</p>
<p class="calibre9">“Look! Look!” cried Porter. “It’s yours, Perse.
See the tag, ‘Miss Persis Holmes.’ Hurrah for you!”</p>
<p class="calibre9">“What! What!” cried Persis. “For me?”</p>
<p class="calibre9">“Yes,” certified Millicent. “And that is the secret.
You can’t guess who gave it to you—grandma.”</p>
<p class="calibre9">“Grandma!” echoed Persis.</p>
<p class="calibre9">“Yes; when she found you went for the doctor,
and got him here in such a jiffy, she gave in, I heard
her say to papa; and she said you had given up your
visit so generously, and were such a comfort while
they were all away, that she wanted you to have a
wheel. Isn’t it a beauty?”</p>
<p class="calibre9">“Oh, you dear, beautiful thing!” And Persis, in
the exuberance of her joy, knelt on the floor, giving
the wheel a rapturous hug. “And to think that
grandma, of all people, should give it to me. Where
is she? I must thank her for it right away.” And
the happy girl sped up-stairs to where, at her sunny
window filled with flowering plants, grandma sat.</p>
<p class="calibre9">Persis could hardly wait for the “come in” which
answered her knock before she burst into the room.
“Oh, grandma,” she cried, “I am the happiest girl in
town! How did you come to be so dear? You don’t
know how I thank you. I never dreamed of such a
thing from you.”</p>
<p class="calibre9"><span id="Page_40" title="[Pg 40]"></span></p>
<p class="calibre9">Grandma smiled. “Well, my child,” she confessed,
“I remind myself of my old grandfather, Judge Herrick,
who used to insist that a horse and carriage were
rapid enough for him, until it came to the matter of
getting important testimony for a law-suit, and then
the fastest express train couldn’t put on too much
steam for him. I hope I have lived long enough to
accept innovations gracefully when I am convinced
of their value. Not to alter an opinion often indicates
obstinacy rather than strength of character, and
your grandma doesn’t want to be called an obstinate
old woman.” And grandma laughed. But Persis
felt that there was a little hint to herself hidden in
the last remark, and it had its effect in a more persuasive
way than could have resulted from any didactic
lecture.</p>
<p class="calibre9">“And you don’t care if I do go off the block?” said
the girl, her speaking eyes full of happiness.</p>
<p class="calibre9">“No, dear; so long as you don’t go into the crowded
streets I shall not veto your riding anywhere that is
safe. I leave that part of it to your own good judgment.
Grandma appreciates your consideration of her
too much to hamper you; for I am convinced that
your father would have given you a wheel long ago
if you had been willing to set aside my feeling in the
matter.” And grandma drew the grateful girl close
to her with a gentle smile on the dear old face.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?548fda54